import { Component } from '@angular/core';
import { PerimetersService } from '../../../@core/utils';

import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { DataType, FilterType } from '../../../@core/perimeter-filter';
import { first, map, Observable } from 'rxjs';
import { PerimetersFiltersDialogComponent } from '../perimeters-filters-dialog/perimeters-filters-dialog.component';
import { NbDialogService } from '@nebular/theme';
import { KPI } from '../../../@core/api';


@Component({
  selector: 'app-perimeters-active-filters',
  styleUrls: ['./perimeters-active-filters.component.scss'],
  templateUrl: './perimeters-active-filters.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    AsyncPipe,
  ],
})
export class PerimetersActiveFiltersComponent {

  private perimeterDialogOpened: boolean = false;

  public activeFilters$: Observable<{label: string, values: string}[]> = this.perimetersService.activePerimeterFilters$.pipe(
    map((filters) => {
      return filters
        .sort((filter) => filter.id === 'parent-perimeter-type' ? -1 : 1)
        .map((filter) => {
          const isObjectDataType = [DataType.DATA_TYPE_FK, DataType.DATA_TYPE_USER].includes(filter.dataType);
          const isValueFilter = filter.filtering === FilterType.FILTER_VALUE;
          const valuesKey = isValueFilter ? 'selectedValues' : 'selectedRangeValues';
          return {
            label: filter.label,
            values: filter[valuesKey]
              ?.map((value) => isObjectDataType
                ? (filter.availableValues as KPI.ReferenceDataValue[]).find((availableValue) => availableValue.id === value)?.label
                : value
              )
              .join(', ')

          };
        });
    }),
  );

  constructor(
    private perimetersService: PerimetersService,
    private dialogService: NbDialogService,
  ) { }

  public openFiltersDialog(): void {
    if (!this.perimeterDialogOpened) {
      this.perimeterDialogOpened = true;
      const filtersDialog = this.dialogService.open(
        PerimetersFiltersDialogComponent,
        {
          autoFocus: false,
        },
      );

      filtersDialog.onClose.pipe(first()).subscribe(() => {
        this.perimeterDialogOpened = false;
      });
    }
  }

}
